module.exports = __webpack_public_path__ + "img/logo-CO2.26f3a622.svg";